//import React from 'react';
const PAGE = [
  {
    "content": `Nombre`
  },
  {
    "content": `Identificación del tratamiento`
  },
  {
    "content": `Creado`
  },
  {
    "content": "Ver"
  },
  {
    "content": "No se encontraron artículos"
  }
];


export default PAGE;